var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chartheight",style:({ width: '100%'}),attrs:{"id":"order-care-bar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }